// Vue
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {Communication} from "../../communication/Communication";
import {InputGroup} from "../../input_group/InputGroup";
import {CommunicationModuleMessageInput} from "../communication_module_message_input/CommunicationModuleMessageInput";
import {Link} from "../../link/Link";
import {CommunicationMessage} from "../../../../interfaces/CommunicationMessage";

@Component({
    name: 'CommunicationModuleMessageBlock',
    mixins: [
        template,
    ],
    components: {
        Communication,
        InputGroup,
        CommunicationModuleMessageInput,
        Link
    }
})
export class CommunicationModuleMessageBlock extends Vue {

    @Prop()
    private message!: CommunicationMessage

    @Prop({default: true})
    private subjectOptional!: boolean

    @Prop()
    private recipientList!: object[]

    @Prop()
    private labelRecipientListField!: string

    @Prop()
    private labelMessageField!: string

    @Prop()
    private labelSubjectField!: string

    @Prop()
    private labelAttachmentField!: string

    @Prop()
    private answerButtonText!: string

    @Prop()
    private removeAttachmentLinkText!: string

    @Prop()
    private submitButtonText!: string

    @Prop()
    private abortButtonText!: string

    @Prop()
    private labelRefreshMessages!: string

    @Prop()
    private supportedFileTypes!: string[]

    @Prop()
    private maxFileSize!: number

    @Prop()
    private errorTooLarge!: string

    @Prop()
    private errorUnsupportedType!: string

    private showAnswerForm: boolean = false

    private emptyRecipientList: object[] = []

    get sender() {
        return this.message['sender'] || "anonymous"
    }

    get isRoot() {
        return this.message['parentId'] === null || this.message['parentId'] === "null" || this.message['parentId'] === "0"
    }

    get messageHTML () {
        if (this.message['text']) {
            return this.message['text'].replace(/\n/g, "<br />");
        } else {
            return '';
        }
    }

    onAnswerClick () {
        this.showAnswerForm = !this.showAnswerForm
    }

    sendMessage (parentId, subject, text, recipient, attachments) {
        this.$emit("sendMessage", parentId, subject, text, recipient, attachments)
        this.showAnswerForm = false
    }
}